import { c as _c } from "react/compiler-runtime";
import { useEffect, useEffectEvent } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { abrirSimulacaoDoAdmin, contextoDoAdminFechado, trocarEscritorioDaSimulacaoDoAdmin } from '../store/actions';
import { selectContextoDoAdmin, selectSuperficieDaSimulacao } from '../store/selectors';
import type { ContextoDaSimulacaoDoAdmin, ContextoDaSimulacaoDoAdminArgs } from '../types';

/**
 * Põe o estado da simulação na superfície ADMIN do fluxo da URL enquanto a tela estiver montada
 * (conversa ou assinatura de teste). Ao sair, a superfície volta à do cliente: o "Testar meus
 * agentes" na mesma sessão não pode herdar o escritório escolhido no admin.
 *
 * O escritório da URL só vale na abertura. Depois, a troca fica no estado e vai para a URL por
 * `replaceState`, para a recarga voltar ao mesmo escritório (CA-9) sem reabrir o contexto.
 */
export function useContextoDaSimulacaoDoAdmin(t0) {
  const $ = _c(17);
  const {
    flowId,
    escritorioIdInicial
  } = t0;
  const dispatch = useAppDispatch();
  const superficie = useAppSelector(selectSuperficieDaSimulacao);
  const contexto = useAppSelector(selectContextoDoAdmin);
  let t1;
  if ($[0] !== dispatch || $[1] !== escritorioIdInicial) {
    t1 = fluxo => {
      dispatch(abrirSimulacaoDoAdmin({
        flowId: fluxo,
        escritorioId: escritorioIdInicial
      }));
    };
    $[0] = dispatch;
    $[1] = escritorioIdInicial;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const abrir = useEffectEvent(t1);
  let t2;
  if ($[3] !== abrir || $[4] !== dispatch || $[5] !== flowId) {
    t2 = () => {
      abrir(flowId);
      return () => {
        dispatch(contextoDoAdminFechado());
      };
    };
    $[3] = abrir;
    $[4] = dispatch;
    $[5] = flowId;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== dispatch || $[8] !== flowId) {
    t3 = [dispatch, flowId];
    $[7] = dispatch;
    $[8] = flowId;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  useEffect(t2, t3);
  let t4;
  if ($[10] !== contexto?.escritorioId || $[11] !== dispatch) {
    t4 = escritorioId => {
      if (!escritorioId || escritorioId === contexto?.escritorioId) {
        return;
      }
      dispatch(trocarEscritorioDaSimulacaoDoAdmin(escritorioId));
      const params = new URLSearchParams(window.location.search);
      params.set("escritorioId", escritorioId);
      window.history.replaceState(null, "", `?${params.toString()}`);
    };
    $[10] = contexto?.escritorioId;
    $[11] = dispatch;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const trocarEscritorio = t4;
  const t5 = superficie === "ADMIN" && contexto?.flowId === flowId;
  const t6 = contexto?.escritorioId ?? null;
  let t7;
  if ($[13] !== t5 || $[14] !== t6 || $[15] !== trocarEscritorio) {
    t7 = {
      pronto: t5,
      escritorioId: t6,
      trocarEscritorio
    };
    $[13] = t5;
    $[14] = t6;
    $[15] = trocarEscritorio;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}